import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { JourneyTemplateEditor } from "../../../components/admin/journey/JourneyTemplateEditor";
import TutorialJourneyActivatorsService from "../../../services/TutorialJourneyActivatorsService";
import React from "react";
import { useTutorialJourneyProfiles } from "../hooks/useTutorialJourneyProfiles";

export const TUTORIAL_JOURNEY_ACTIVATOR_KEY = "tutorial-journey-activator";

export function JourneyActivatorTemplate() {
  const { id } = useParams();

  const { data, isLoading: activatorsIsLoading } = useQuery({
    queryKey: [TUTORIAL_JOURNEY_ACTIVATOR_KEY, Number(id)],
    queryFn: () =>
      TutorialJourneyActivatorsService.getTutorialJourneyActivatorById(
        Number(id),
      ),
    enabled: true,
    refetchOnMount: "always",
  });

  const { data: profilesVm, isLoading: profilesIsLoading } =
    useTutorialJourneyProfiles();

  const isLoading = activatorsIsLoading || profilesIsLoading;

  return (
    <>
      {!isLoading && (
        <>
          <JourneyTemplateEditor
            data={data}
            profiles={profilesVm?.profiles}
            displayMode="dialog"
          />
        </>
      )}
    </>
  );
}
